export enum ColorsEnum {
  yellow = '#FEF200',
  orange = '#FB6600',
  red = '#D40000',
  pink = '#FD0EBF',
  purple = '#B200EE',
  blue = '#0017F9',
  green = '#3CB043',
  brown = '#7C4701',
  gray = '#828282',
  black = '#000000',
  white = '#FFFFFF',
}

export const colors = [
  { label: 'Yellow', value: 'yellow' },
  { label: 'Orange', value: 'orange' },
  { label: 'Red', value: 'red' },
  { label: 'Pink', value: 'pink' },
  { label: 'Purple', value: 'purple' },
  { label: 'Blue', value: 'blue' },
  { label: 'Green', value: 'green' },
  { label: 'Brown', value: 'brown' },
  { label: 'Gray', value: 'gray' },
  { label: 'Black', value: 'black' },
  { label: 'White', value: 'white' },
];
